import { DetectedProduct, getRandomProduct } from './productScanner'

const NAMES = [
  'James',
  'Maria',
  'Carlos',
  'Sarah',
  'Diego',
  'Emily',
  'Martin',
  'Jessica',
  'Santiago',
  'Ashley',
  'Andrew',
  'Sofia',
  'Matthew',
  'Isabella',
  'Alex',
  'Valeria',
  'Daniel',
  'Megan',
  'Michael',
  'Gabriela',
  'Nicolas',
  'Rachel',
  'Sebastian',
  'Lauren',
  'David',
  'Victoria',
  'Ryan',
  'Natalie',
  'Lucas',
  'Julia',
  'Kevin',
  'Amanda',
  'Chris',
  'Stephanie',
  'Brandon',
  'Michelle',
  'Tyler',
  'Nicole',
  'Jason',
  'Samantha',
]

const CITIES = [
  'New York',
  'Los Angeles',
  'Chicago',
  'Houston',
  'Phoenix',
  'Philadelphia',
  'San Antonio',
  'San Diego',
  'Dallas',
  'Austin',
  'Miami',
  'Denver',
  'Seattle',
  'Boston',
  'Nashville',
  'Portland',
  'Las Vegas',
  'Atlanta',
  'San Francisco',
  'Charlotte',
  'Tampa',
  'Orlando',
  'Minneapolis',
  'Raleigh',
]

// Rolling history to avoid repeating names
const recentNames: string[] = []
const MAX_HISTORY = 10

function getUniqueName(): string {
  const available = NAMES.filter((n) => !recentNames.includes(n))
  const pool = available.length > 0 ? available : NAMES
  const name = pool[Math.floor(Math.random() * pool.length)]

  recentNames.push(name)
  if (recentNames.length > MAX_HISTORY) {
    recentNames.shift()
  }

  return name
}

export interface PurchaseNotification {
  buyerName: string
  city: string
  product: DetectedProduct
}

export function generateFakePurchase(
  products: DetectedProduct[],
): PurchaseNotification {
  const buyerName = getUniqueName()
  const city = CITIES[Math.floor(Math.random() * CITIES.length)]
  const product = getRandomProduct(products)

  return {
    buyerName,
    city,
    product,
  }
}
